<div [formGroup]="form">
  <div class="book">
    <label  for="book">{{bookType}} Book <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <input type="text" id="bk" name="book"  formControlName="book" maxlength="10" aria-describedby="book_error">
    <div id="book_error" class="help-block" role="alert">
      <span *ngIf="form.get('book').errors?.required && form.get('book').touched">Enter book</span>
      <span *ngIf="form.get('book').errors?.pattern && form.get('book').touched">Use numbers in Book</span>
    </div>
  </div>
  <div class="space"></div>
  <div class="page">
    <label for="page">{{bookType}}  Page <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <input type="text" id="pg" name="page"  formControlName="page" maxlength="10" aria-describedby="page_error">
    <div id="page_error" class="help-block" role="alert">
      <span *ngIf="form.get('page').errors?.required && form.get('page').touched">Enter page</span>
      <!--<span *ngIf="form.get('page').errors?.pattern && form.get('page').touched">Use numbers in Page.</span>-->
    </div>
  </div>
</div>
